import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Chip,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import Loader from "../../helpers/Loader";
import { useLazyGetPromoByIdQuery } from "../../services/promocodes";
import moment from "moment";
import { errorToast } from "../../helpers";

const PromocodeDetails = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const [promoDetails, setPromoDetails] = useState<any>(null);
  const [getPromoById, { isLoading }] = useLazyGetPromoByIdQuery();

  const fetchPromoDetails = async () => {
    try {
      const response = await getPromoById({ id: _id }).unwrap();
      if (response.statusCode === 200) {
        setPromoDetails(response.data);
      }
    } catch (error) {
      console.error(error);
      errorToast("Failed to load promocode details");
    }
  };

  useEffect(() => {
    if (_id) {
      fetchPromoDetails();
    }
  }, [_id]);

  const getDiscountTypeText = (type: number) => {
    return type === 1 ? "Flat Amount" : "Percentage";
  };

  const getPromoTypeText = (type: number) => {
    switch (type) {
      case 1:
        return "One-to-One";
      case 2:
        return "Class";
      case 3:
        return "Both";
      default:
        return "-";
    }
  };

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Promocode Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-promocodes")}
          >
            Back
          </Button>
        </div>
        <Loader isLoad={isLoading} />

        {promoDetails && (
          <Card className="cards">
            <CardContent sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Promo Code Name
                  </Typography>
                  <Typography className="view_text">
                    {promoDetails.name || "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Custom Code Name
                  </Typography>
                  <Typography className="view_text">
                    {promoDetails.codeName || "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Max User</Typography>
                  <Typography className="view_text">
                    {promoDetails.maxUser || "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Discount Type
                  </Typography>
                  <Typography className="view_text">
                    {getDiscountTypeText(promoDetails.discountType)}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    {promoDetails.discountType === 1
                      ? "Discount Amount"
                      : "Discount (%)"}
                  </Typography>
                  <Typography className="view_text">
                    {promoDetails.discount || "-"}
                    {promoDetails.discountType === 2 ? "%" : ""}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Tutor</Typography>
                  <Typography className="view_text">
                    {promoDetails.tutor?.name || "All Tutors"}
                    {promoDetails.tutor?.userName && (
                      <span> ({promoDetails.tutor.userName})</span>
                    )}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Expiry Date</Typography>
                  <Typography className="view_text">
                    {promoDetails.expiryDate
                      ? moment(promoDetails.expiryDate).format(
                          "DD-MM-YYYY HH:mm"
                        )
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Start Date</Typography>
                  <Typography className="view_text">
                    {promoDetails.startDate
                      ? moment(promoDetails.startDate).format(
                          "DD-MM-YYYY HH:mm"
                        )
                      : "Immediately"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Status</Typography>
                  <Typography className="view_text">
                    {new Date(promoDetails.expiryDate) > new Date()
                      ? "Active"
                      : "Expired"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Class Type</Typography>
                  <Typography className="view_text">
                    {getPromoTypeText(promoDetails.type)}
                  </Typography>
                </Grid>

                {promoDetails.type && promoDetails.type !== 1 && (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {promoDetails.allClasses ? "All Classes" : "Class IDs"}
                    </Typography>
                    {promoDetails.allClasses ? (
                      <Typography className="view_text">All Classes</Typography>
                    ) : (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {promoDetails.classIds?.map((id: string) => (
                          <Chip key={id} label={id} />
                        ))}
                      </Box>
                    )}
                  </Grid>
                )}

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Created At</Typography>
                  <Typography className="view_text">
                    {promoDetails.createdAt
                      ? moment(promoDetails.createdAt).format(
                          "DD-MM-YYYY HH:mm"
                        )
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Times Used</Typography>
                  <Typography className="view_text">
                    {promoDetails.usedCount || "0"} times
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}
      </div>
    </MainContainer>
  );
};

export default PromocodeDetails;
